ThemeJS.Card_Links = ( function ( $ ) {

    function init ( $items = null ) {
        $items = $items ?? $( 'section.card_links.large-cards .link-card' );
        $items.each( function () {
            const height = $( 'div.wysiwyg-content', this ).outerHeight();
            $( 'div.height-set', this ).height( height );
            $( 'div.content-wrap', this ).css( 'padding-top', `${ height }px` );
        });
    }

    $(window).on( 'breakpoint_changed', function () {
        init();
    });
    $( function () {
        init();
    });

    return {
        init
    };

})( jQuery );